<!--
  The Avocado brand mark (DESIGN.md §5.8): half an avocado, leaning right.
  'line' is the 1.5 px outline in currentColor, for use inside the UI;
  'color' is the filled mark used for the favicon and app icons.
-->
<script lang="ts">
  export let variant: 'line' | 'color' = 'line'
  export let size: string = '1.5rem'
</script>

<svg
  class="avocado-mark"
  viewBox="0 0 24 24"
  width={size}
  height={size}
  aria-hidden="true"
  fill="none"
  stroke-linejoin="round"
>
  {#if variant === 'color'}
    <path
      d="M18.57 15.31A7.17 7.17 0 1 1 6.67 8.98L12.71 3.57A4.2 4.2 0 0 1 19.68 7.28Z"
      fill="#3F5A27"
    />
    <path d="M16.68 15.05A5.27 5.27 0 1 1 7.94 10.4L13.98 4.99A2.3 2.3 0 0 1 17.79 7.02Z" fill="#CFDBA0" />
    <circle cx="11.62" cy="14.03" r="2.86" fill="#7B5436" />
  {:else}
    <g stroke="currentColor" stroke-width="1.5">
      <path d="M18.57 15.31A7.17 7.17 0 1 1 6.67 8.98L12.71 3.57A4.2 4.2 0 0 1 19.68 7.28Z" />
      <path d="M16.68 15.05A5.27 5.27 0 1 1 7.94 10.4L13.98 4.99A2.3 2.3 0 0 1 17.79 7.02Z" opacity=".55" />
      <circle cx="11.62" cy="14.03" r="2.4" fill="currentColor" fill-opacity=".2" />
    </g>
  {/if}
</svg>

<style lang="scss">
  .avocado-mark {
    flex-shrink: 0;
  }
</style>
